import * as React from 'react'
import { Loader } from 'components/loader'
import alertStyle from 'components/alert/alert.css'
import { ModalLayerStore } from 'stores/modal-layer-store'
import { AccountStore } from '../account-store'
import { ConfirmDeleteReturnValue } from '../account'
import { ConfirmDelete } from 'modules/dashboard/user/confirm-delete/confirm-delete'

export const displayConfirmDeleteTeam = async (
  actionModalStore: ModalLayerStore,
  accountStore: AccountStore,
  teamName: string,
  teamGroupId: string,
  t: (...args: any) => string,
) => {
  return new Promise<ConfirmDeleteReturnValue>(res => {
    const onClose = async (closeButton: ConfirmDeleteReturnValue) => {
      actionModalStore.removeModal()
      return res(closeButton)
    }

    const onConfirmDelete = async () => {
      onClose(ConfirmDeleteReturnValue.CloseButton)
      accountStore.deleteTeam(teamGroupId, teamName)
    }

    actionModalStore.addModal(
      <div key={actionModalStore.getKey()} className={alertStyle.darkenBackground}>
        {accountStore.isLoadingModal ? (
          <Loader />
        ) : (
          <ConfirmDelete
            confirmQuestion={'teams.confirmDelete'}
            confirmText={t('teams.confirmDeleteTeam', { teamName })}
            onClose={() => onClose(ConfirmDeleteReturnValue.CloseButton)}
            onConfirm={() => onConfirmDelete()}
          />
        )}
      </div>,
    )
  })
}
